import React from "react";
import RichText from "components/rich-text";
import { SocialMedia } from "components/link-types";
import { Swiper, SwiperSlide } from "components/swiper";
import { Mousewheel } from "swiper";
import Image from "components/image";
import { ReactComponent as Instagram } from "assets/svgs/instagram.svg";

const settings = {
	modules: [Mousewheel],
	slidesPerView: 2.5,
	slidesPerGroup: 2,
	preventClicks: true,
	preventClicksPropagation: false,
	spaceBetween: 10,
	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	breakpoints: {
		1024: {
			preventClicks: true,
			preventClicksPropagation: false,
			simulateTouch: true,
			spaceBetween: 30,
			slidesPerView: 3.4,
			slidesPerGroup: 3,
		},
		420: {
			preventClicks: true,
			preventClicksPropagation: false,
			simulateTouch: true,
			spaceBetween: 30,
			slidesPerView: 2,
			slidesPerGroup: 2,
		},
	},
};

const InstaGallery = ({ data: props }) => (
	<div className="w-full text-center mt-10 m-auto md:w-11/12 py-10 hd-screen-max-width">
		<RichText value={props.content} />
		{props.showSocial && (
			<div className="flex justify-center gap-2">
				<SocialMedia list={["instagram", "facebook", "youtube", "linkedin", "tiktok"]} />
			</div>
		)}
		{<Swiper {...settings} className="mt-10">
			{props.feed?.map((d) => (
				<SwiperSlide className="group w-1/3" key={d._id}>
					<a href={d.permalink} target="_BLANK" rel="noreferrer" aria-label={`View post (opens in new tab)`}>
						<Image className="md:max-h-[25rem] aspect-square" image={d.post.asset} alt={d.post.alt} />
						<div className="insta-post-overlay">
							<div className="flex justify-center mb-2">
								<Instagram />
							</div>
							<span>{d.caption.substring(0, 150) + "..."}</span>
						</div>
					</a>
				</SwiperSlide>
			))}
		</Swiper>}
	</div>
);

export default InstaGallery;
